import type { RootState } from "../state";

// 此文件包含基础连接检查和状态管理方法

export function checkConnectionStatus(
  this: RootState & { [key: string]: any },
  roomId: string
) {
  const state = this.roomStates.get(roomId);
  if (!state) return { connected: false, reason: "Room not found" };

  const wsConnected = state.audioQueueWs?.readyState === WebSocket.OPEN;
  const commentConnected = state.commentWs?.readyState === WebSocket.OPEN;

  return {
    connected: wsConnected && commentConnected,
    audioQueueConnected: wsConnected,
    commentConnected: commentConnected,
    sessionId: state.sessionId
  };
}

export function disconnectRoom(
  this: RootState & { [key: string]: any },
  roomId: string
) {
  const state = this.roomStates.get(roomId);
  if (!state) return;

  // 断开所有连接
  if (state.commentWs) {
    state.commentWs.close();
    state.commentWs = null;
  }

  if (state.audioQueueWs) {
    state.audioQueueWs.close();
    state.audioQueueWs = null;
  }

  // 停止音频播放
  if ((state as any).howlerPlayer) {
    (state as any).howlerPlayer.pause();
    (state as any).howlerPlayer = null;
  }

  // 清理计时器

  // 重置连接状态
  state.isBound = false;
  state.isPlaying = false;
  state.commentWsReconnectCount = 0;
  state.audioQueueWsReconnectCount = 0;
}
